<template>
  <div class="list-detail">
    <navCom :navActive="navActive"></navCom>
    <div class="current-location">
      <i class="current-location-icon"><img src="../../static/images/syy-images/address-icon.png" width="100%"></i>
      <p class="current-location-txt">
        <span>您现在的位置：</span>
        <router-link to="/">
          <a href="javascript:;">首页</a>
        </router-link>
        <span class="symbol">></span>
        <router-link to="/live-class">
          <a href="javascript:;" >直播课</a>
        </router-link>
        <span class="symbol">></span>
        <a href="javascript:;">{{Course_Online.course_name}}</a>
      </p>
    </div>
    <!-- 详情页 top start -->
    <div class="list-detail-main">
      <div class="course-detail-inner">
        <div class="course-detail-img">
          <img :src="Course_Online.course_pic" :onerror="errorImg01" width="100%" height="100%">
        </div>
        <div class="course-detail-box">
          <div class="title"><h3>{{Course_Online.course_name}}</h3></div>
          <p class="course-label">
            <span v-for="(item,index) of course_label">{{item.a}}</span>
          </p>
          <p class="price">
            <span class="course-detail-info-txt letter-space">价      格：<i></i></span>
            <span class="price-red">￥{{Course_Online.preferential_price}}</span>
            <span class="price-gray">原价：{{Course_Online.original_price}}</span>
          </p>
          <div class="course-content">
            <p class="course-content-txt">{{Course_Online.live_start_time}}至{{Course_Online.live_end_time}}</p>
          </div>
          <div class="purchase-btn">
            <p @click="payFun(Course_Online.id)" class="purchase-price yellow-self-btn">立即购买</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 详情页 top end -->
    <!-- 详情页 bottom start -->
    <div class="list-detail-course">
      <div>
        <!-- 授课教师 start -->
        <div class="list-detail-course-item">
          <div class="title">
            <p>授课老师</p>
          </div>
          <div class="course-teacher">
            <div class="course-teacher-img"><img :src="teacher_info.teacher_pic" width="100%" height="100%"></div>
            <div class="course-teacher-info">
              <h3 class="name">{{teacher_info.teacher_name}}</h3>
              <div style="display: flex;">
                <p class="txt">毕业大学：{{teacher_info.school}}</p>
              </div>
              <p class="txt">教学经验：{{teacher_info.experience}}</p>
              <p class="txt">教学特点：{{teacher_info.peculiarity}}</p>
            </div>
          </div>
        </div>
        <!-- 授课教师 end -->
        <!-- 课题大纲 start -->
        <div class="list-detail-course-item" style="margin-bottom: 0;">
          <div class="title">
            <p>课题大纲</p>
          </div>
          <ul class="course-outline">
            <li v-for="(item,index) of course_lessons" :key="index">
              <p class="course-outline-info" >
                <i class="radius"></i>
<!--                <span>视频时长：{{item.video_time}}分钟</span>-->
                <span>视频时长 ：{{item.start}}至{{item.end}}</span>
              </p>
              <div class="course-outline-div">
                <h3 class="course-outline-title">{{item.lessons_name}}</h3>
                <p class="course-outline-name">授课老师：{{item.teacher_name}}</p>
              </div>
            </li>
          </ul>
        </div>
        <!-- 课题大纲 end -->
      </div>
    </div>
    <!-- 详情页 bottom end -->
    <footerCom></footerCom>
  </div>

</template>

<script>
  import navCom from '../components/welcome-nav'
  import footerCom from '../components/foot'
  import tool from '../assets/js/tool'
  import purchase from './payment'
  import axios from 'axios'
  export default {
    name: "live_detail_class",
    components: {
      navCom,
      footerCom,
    },
    data () {
      return {
        errorImg01:'this.src="' + require('../../static/images/zmr-images/default.jpg') + '"',
        navActive:2,
        course_id:this.$route.query.course_id,//课程id
        orderId: 1,
        countDownList: [],
        groupCur:0,//当前选择拼团索引
        tipShow:false,//是否立即支付提示弹窗
        Course_Online:Object,//课程详情
        teacher_info:Object,//教师详情
        course_label:Array,//优惠循环
        course_lessons:Array,//课程大纲循环
      }
    },
    computed:{
      isShowLogin(){
        return this.$store.state.loginShow;
      },
      navCurrent(){
        return this.$store.state.navCurrent;
      }
    },
    methods: {
      // 获取课程详情
      getCourse(){
        let data ={
          user_id:this.$store.state.uuid,
          course_id:this.course_id,
        };
        tool.postData('Course_Online/getLiveCourseDetails', data, (res)=>{
          this.Course_Online=res.data.data
          this.teacher_info=res.data.data.teacher_info
          this.course_label=res.data.data.course_label
          this.course_lessons=res.data.data.course_lessons
        })
      },
      payFun(id){
        console.log(456455,id)
        if(this.$store.state.uuid==''){
          this.$toast.center('请先登录！')
        }else {
          let data ={
            user_id:this.$store.state.uuid,
            course_id:this.course_id,
          };
          var that=this;
          axios.post('/api/Center_Order/createOrder', data)
            .then(function (res) {
              if (res.data.code == 200) {
                that.$router.push({
                  name: 'purchase-course',
                  component: purchase,
                  query: {
                    course_id: id,
                    navActive:1,
                    order_num:res.data.data.order_num
                  },
                });
              } else {
                if(res.data.code == 400){
                  that.$toast.center(res.data.msg)
                }
              }
            })
        }
      }
    },
    mounted() {
      this.getCourse();
      // this.getCourseDetails()
    },

  }
</script>

<style scoped>
  .current-location{
    padding: 27px 0;
    box-sizing: border-box;
    width:1220px;
    margin:0 auto;
  }
  .current-location-icon{
    width: 13px;
    display: inline-block;
  }
  .current-location-txt{
    display: inline-block;
    vertical-align: bottom;
    margin-left: 4px;
    color: #727272;
    font-size: 16px;
  }
  .current-location-txt a{
    color: #727272
  }
  .current-location-txt a:last-child{
    color: #494949
  }
  .symbol{
    margin: 0 5px;
  }
  .list-detail{
    background-color:#f4f4f4;
  }
  .list-detail-main{
    width: 1220px;
    margin: 0 auto;
    padding-top: 45px;
    background-color: #fff;
  }
  .course-detail-inner{
    width: 1140px;
    margin: 27px auto 0;
    padding-bottom: 50px;
  }
  .course-detail-img{
    width: 498px;
    height: 370px;
    display: inline-block;
  }
  .course-detail-box{
    width: 564px;
    display: inline-block;
    vertical-align: top;
    padding-top: 15px;
    box-sizing: border-box;
    margin-left: 65px;
  }
  .course-detail-box .title{
    display: flex;
    justify-content: space-between;
  }
  .course-detail-box .title h3{
    font-size: 26px;
    color: #282828;
    font-weight: bold;
    line-height: 80px;
  }
  .share-golden-beans b{
    font-size: 14px;
    color: #ce0000;
    font-weight: bold;
  }
  .price{
    margin-bottom: 35px;
  }
  .course-detail-info-txt{
    font-size: 18px;
    color: #6b6b6b;
  }
  .price-red{
    font-size: 28px;
    color: #ce0000;
    font-weight: bold;
  }
  .price-gray{
    font-size: 14px;
    color: #999;
    text-decoration:line-through;
    margin-left: 13px;
  }
  .course-detail-info-txt b{
    color: #ce0000;
    font-weight: bold;
  }
  .letter-space{
    text-align: justify;
    text-align-last: justify;
    text-justify: distribute;
    width: 90px;
    display: inline-block;
  }
  .letter-space i{
    display:inline-block;
  }
  .purchase-btn{
    font-size: 0;
    width: 360px;
    border-radius: 5px;
    overflow: hidden;
    margin-top: 40px;
  }
  .purchase-btn a{
    width: 180px;
    height: 60px;
    display: inline-block;
  }
  .purchase-btn a p{
    color: #fff;
    text-align: center;
    padding-top: 7px;
    box-sizing: border-box;
    font-weight: bold;
  }
  .yellow-btn{
    background: #ff7800;
  }
  .red-btn{
    background: #ff1e00;
  }
  .purchase-btn .yellow-self-btn{
    width: 212px;
    height: 47px;
    color: #fff;
    line-height: 47px;
    text-align: center;
    background-color: #ff7800;
    border-radius: 5px;
    cursor: pointer;
  }
  .yellow-self-btn .purchase-price{
    font-size: 16px;
    padding: 0;
  }
  .purchase-price{
    font-size: 24px;
  }
  .purchase-rules{
    font-size: 16px;
  }
  .list-detail-course{
    width:1220px;
    margin:20px auto 0;
  }
  .list-detail-course-item{
    padding:30px;
    box-sizing: border-box;
    background-color: #fff;
    margin-bottom: 20px;
  }
  .list-detail-course-item > .title{
    width: 100%;
    border-bottom: 1px solid #dcdcdc;
  }
  .list-detail-course-item > .title > p{
    font-size: 22px;
    display: inline-block;
    font-weight: bold;
    color: #1970ff;
    line-height: 42px;
    border-bottom: 3px solid #1970ff;
  }
  .course-teacher{
    margin-top: 30px;
  }
  .course-teacher-img{
    width: 155px;
    height: 155px;
    display: inline-block;
    vertical-align: top;
    border-radius: 50%;
    overflow: hidden;
  }
  .course-teacher-info{
    display: inline-block;
    margin-top: 20px;
    margin-left: 36px;
    width:80%;
  }
  .course-teacher-info .name{
    font-size: 24px;
    color: #5d5d5d;
  }
  .course-teacher-info .txt{
    font-size: 16px;
    color: #5d5d5d;
    margin-top: 25px;
    line-height: 26px;
  }

  .spell-list{
    width: 590px;
    margin-left: 36px;
    margin-top: 30px;
  }
  .spell-list-item{
    display: flex;
    justify-content: space-between;
  }
  .spell-list-people i{
    width: 50px;
    height: 50px;
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;
  }
  .spell-list-info{
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
  }
  .spell-list-info span{
    display: block;
    font-size: 16px;
  }
  .spell-list-info span:first-child{
    color: #5d5d5d;
    margin-bottom: 20px;
  }
  .spell-list-info span:last-child{
    color: #a9a9a9;
  }
  .people-num{
    color: #ce0000
  }
  .spell-list-btn{
    width: 95px;
    height: 40px;
    border-radius: 20px;
    background: #ff7800;
    color: #fff;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    cursor: pointer;
  }
  .course-introduce{
    margin: 30px 0 0 30px;
    line-height: 27px;
    font-size: 16px;
    color: #5d5d5d;
  }
  .course-outline{
    margin-top: 17px;
    margin-left: 30px;
  }
  .course-outline pre{
    line-height: 60px;
  }
  .course-outline-info{
    font-size: 16px;
    color: #606060;
    padding-top: 15px;
  }
  .course-outline-info .radius{
    width: 12px;
    height: 12px;
    display: inline-block;
    border-radius: 50%;
    background: #1970ff;
    margin: 0 48px 15px 0;
    vertical-align: top;
  }
  .course-outline-div{
    border-left: 2px solid #c7c7c7;
    padding: 27px 0 27px 60px;
    box-sizing: border-box;
    margin-left: 5px;
  }
  .course-outline-title{
    font-size: 18px;
    color: #131313;
    margin-bottom: 17px;
  }
  .course-outline-name{
    font-size: 16px;
    color: #606060;
  }
  .course-outline li:last-child .course-outline-div{
    border-left: none;
  }
  .not-begun span{
    color: #1970ff
  }
  /*弹窗*/
  .item_container {
    width: 94%;
    margin: 0 auto;
    margin-top: 10px;
    padding: 10px 10px;
    box-sizing: border-box;
    background-color: #fff;
    overflow: hidden;
    box-shadow: 3px 3px 5px #dedede;
  }

  .top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .top_left {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #2b75f9;
  }

  .top_right {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #a0a0a0;
  }

  .line {
    width: 2px;
    height: 15px;
    float: left;
    margin-right: 7px;
  }

  .line_1 {
    background: linear-gradient(#3f82fc, #579bfd, #3f82fc);
  }

  .line_2 {
    background: linear-gradient(#fb66a3, #fca3b1, #fb66a3);
  }

  .line_3 {
    background: linear-gradient(#795ff8, #956ff7, #795ff8);
  }

  .more_icon {
    width: 8px;
    margin-left: 5px;
  }

  .main_item {
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  .main_item_wrapper{
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .main_item_main{
    display: flex;
    justify-content: space-between;
  }
  .main_item_left {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #454545;
  }

  .avatar {
    width: 35px;
    height: 35px;
    margin-right: 10px;
    border-radius: 50%;
  }

  .main_item_right {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .rest {
    margin-right: 10px;
  }

  .rest_seat {
    font-size: 13px;
    color: #3b3b3b;
    text-align: right;
  }

  .rest_time {
    font-size: 10px;
    color: #7b7a7a;
    text-align: right;
  }

  .count_down {
    margin-left: 5px;
  }

  .button {
    width: 60px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #fb4a45;
    color: #fff;
    border-radius: 5px;
    font-size: 12px;
    letter-spacing: 2px;
  }

  .red {
    color: #fb4a45;
    margin: 0 1px;
  }

  .popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
  }

  .mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .popup_main {
    position: fixed;
    top: 50%;
    left: 50%;
    overflow: hidden;
    transform: translate(-50%, -50%);
    padding: 50px 27px;
    box-sizing: border-box;
    background-color: #fff;
    border: 5px;
    border-radius: 10px;
  }

  .close_wrapper {
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 5px;
    position: absolute;
    top: 12px;
    left: -12px;
  }

  .close_icon {
    width: 20px;
  }

  .popuplist {
    width: 100%;
    overflow: auto;
    max-height: 300px;
  }

  .color_grey {
    font-size: 11px;
    color: #706f6f;
  }

  .host {
    color: #fb4a45;
    margin-left: 5px;
    font-size: 11px;
    width: 100%;
    text-align: left;
    margin-top: 5px;
  }

  .group_info {
    width: 100%;
    padding: 5px 10px;
    box-sizing: border-box;
  }

  .group_info_top {
    text-align: center;
  }

  .group_info_title {
    color: #0c0c0c;
    font-size: 24px;
    font-weight: bold;
  }

  .group_info_text {
    font-size: 14px;
    color: #767676;
    margin-top: 20px;
  }

  .fontred {
    color: #fb4a45;
    font-size: 14px;
  }

  .group_info_mid {
    padding: 40px 0px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .group_images_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 5px 10px;
  }

  .group_mid_images {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }

  .images_name {
    font-size: 14px;
    margin-top: 14px;
    color: #1970ff;
  }

  .btn {
    width: 100%;
    height: 50px;
    color: #fff;
    background-color: #1970ff;
    border-radius: 5px;
    text-align: center;
    line-height: 50px;
    margin-bottom: 10px;
    font-size: 18px;
  }
  .course-label{
    margin-bottom: 10px;
  }
  .course-label span{
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 14px;
    border-radius: 20px;
    margin: 10px 7px 14px 0;
    display: inline-block;
    line-height: 23px;
  }
  .course-label span:nth-child(n){
    color: #e60012;
    border: 1px solid #e60012;
  }
  .course-label span:nth-child(2n){
    color: #2996e2;
    border: 1px solid #2996e2;
  }
  .course-label span:nth-child(3n){
    color: #ff8e00;
    border: 1px solid #ff8e00;
  }
  .course-content{
    display: flex;
  }
  .course-content-txt{
    font-size: 16px;
    color: #888888;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 30px;
  }
  .course-content-icon{
    width: 12px;
    display: inline-block;
    vertical-align: text-top;
    margin-right: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/live-class-detail.vue